import React from "react";
import { Layout, Space } from "antd";
import type { TablePaginationConfig } from "antd/es/table";
import type { CheckboxChangeEvent } from "antd/es/checkbox";
import type { RecordLogItem } from "../../api";
import { LAYOUT } from "../../constants/layout";
import LogFilters from "../LogFilters";
import LogActions from "../LogActions";
import RecordLogTable from "../RecordLogTable";
import type { TableProps } from "antd";

interface ContentProps {
  // 日志相关
  logData: RecordLogItem[];
  loadingLogs: boolean;
  pagination: TablePaginationConfig;
  selectedRowKeys: React.Key[];
  // 过滤器相关
  taskIdFilter: string;
  requestIdFilter: string;
  requestHeaderFilter: string;
  statusFilter: string;
  // 回放相关
  ignoreInterval: boolean;
  replayTarget: string;
  // 事件处理
  onTaskIdFilterChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  onRequestIdFilterChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  onRequestHeaderFilterChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  onStatusFilterChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  onApplyFilter: () => void;
  onTableChange: TableProps<RecordLogItem>["onChange"];
  onRowSelectionChange: (keys: React.Key[]) => void;
  onShowJsonModal: (title: string, content: string) => void;
  onCopyCurl: (requestId: string) => void;
  onCopyText: (text: string | undefined | null, typeLabel?: string) => Promise<void>;
  onIgnoreIntervalChange: (e: CheckboxChangeEvent) => void;
  onReplayTargetChange: (value: string) => void;
  onReplayRequest: () => void;
}

/**
 * 应用内容区组件
 * @param props - 组件属性
 * @returns React 元素
 */
const Content: React.FC<ContentProps> = ({
  logData,
  loadingLogs,
  pagination,
  selectedRowKeys,
  taskIdFilter,
  requestIdFilter,
  requestHeaderFilter,
  statusFilter,
  ignoreInterval,
  replayTarget,
  onTaskIdFilterChange,
  onRequestIdFilterChange,
  onRequestHeaderFilterChange,
  onStatusFilterChange,
  onApplyFilter,
  onTableChange,
  onRowSelectionChange,
  onShowJsonModal,
  onCopyCurl,
  onCopyText,
  onIgnoreIntervalChange,
  onReplayTargetChange,
  onReplayRequest,
}) => {
  return (
    <Layout.Content style={{ padding: LAYOUT.CONTENT.PADDING }}>
      <Space direction="vertical" style={{ width: "100%" }} size="middle">
        <LogFilters
          taskIdFilter={taskIdFilter}
          onTaskIdFilterChange={onTaskIdFilterChange}
          requestIdFilter={requestIdFilter}
          onRequestIdFilterChange={onRequestIdFilterChange}
          requestHeaderFilter={requestHeaderFilter}
          onRequestHeaderFilterChange={onRequestHeaderFilterChange}
          statusFilter={statusFilter}
          onStatusFilterChange={onStatusFilterChange}
          onApplyFilter={onApplyFilter}
        />

        <RecordLogTable
          data={logData}
          loading={loadingLogs}
          pagination={pagination}
          selectedRowKeys={selectedRowKeys}
          onChange={onTableChange}
          onRowSelectionChange={onRowSelectionChange}
          onShowJsonModal={onShowJsonModal}
          onCopyCurl={onCopyCurl}
          onCopyText={onCopyText}
        />

        <LogActions
          selectedRowKeys={selectedRowKeys}
          ignoreInterval={ignoreInterval}
          replayTarget={replayTarget}
          onIgnoreIntervalChange={onIgnoreIntervalChange}
          onReplayTargetChange={onReplayTargetChange}
          onReplayRequest={onReplayRequest}
        />
      </Space>
    </Layout.Content>
  );
};

export default Content; 
